// Define a map of colors for each character
export const colorMap: Record<string, string> = {
  a: '#FFE2E2',
  b: '#BEFAED',
  c: '#FFBEBE',
  d: '#DAEFFF',
  e: '#EDCFDC',
  f: '#DDD7FF',
  g: '#FFD0B7',
  h: '#E0F2FF',
  i: '#D4FAFE',
  j: '#F2DCC5',
  k: '#FEC9DE',
  l: '#E8FFBD',
  m: '#FFB7DE',
  n: '#FFC433',
  o: '#AD33FF',
  p: '#33FF72',
  q: '#FFB833',
  r: '#A2FF33',
  s: '#FF33E5',
  t: '#33CFFF',
  u: '#E0E8D6',
  v: '#72FF33',
  w: '#FF338A',
  x: '#33FFD7',
  y: '#A6FF33',
  z: '#FF337C',
};

// Function to get the background color based on the first character of the name
export const getBackgroundColor = (char: string): string => {
  const lowerChar = char.toLowerCase();
  return colorMap[lowerChar] || '#CCCCCC'; // Default color for unknown characters
};

export const truncateName = (input: string, maxLength: number): string => {
  return input.length > maxLength ? input.slice(0, maxLength) + '...' : input;
};
